<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">套餐名称</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="title" placeholder="请输入套餐名称"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">有效时长</div>
      <div class="row-right">
        <el-radio-group v-model="timeType">
          <el-radio :label="0">长期</el-radio>
          <el-radio :label="1">固定时长</el-radio>
        </el-radio-group>
        <el-date-picker
          v-if="timeType==1"
          class="fixed-width-150 ml10"
          v-model="beginTime"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始日期">
        </el-date-picker>
        <span v-if="timeType==1"> -- </span>
        <el-date-picker
          class="fixed-width-150"
          v-if="timeType==1"
          v-model="endTime"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="label">所属组织</div>
      <div class="row-right">
        <el-cascader
          class="fixed-width-200"
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
          clearable @change="getCommodity(unitNo[unitNo.length-1])"></el-cascader>
      </div>
    </div>
    <div class="row">
      <div class="label">套餐商品</div>
      <div class="row-right">
        <el-select class="fixed-width-200"
                   multiple
                   collapse-tags
                   clearable
                   @change="handleChange"
                   v-model="commodityArray">
          <el-option
            v-for="item in commodityList"
            :key="item.number"
            :label="item.title"
            :value="item.number">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <table class="table-custom">
        <thead>
        <tr>
          <th>商品名称</th>
          <th>适用电池</th>
          <th>价格</th>
          <th>数量</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="commodityArray.length>0">
        <tr v-for="(item,index) in chooseCommodity" :key="index">
          <td>{{ item.title }}</td>
          <td>{{ item.standard ? item.standard + 'V' : '' }}</td>
          <td>฿{{ item.price }}</td>
          <td>
            <el-input v-model="numbers[index]"></el-input>
          </td>
          <td>
            <div class="text-btn fixed-width-75" @click="onDeleteBtnClick(index)">删除</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="5">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="label">套餐价格</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="price" placeholder="请输入套餐价格"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">套餐状态</div>
      <div class="row-right">
        <el-radio-group v-model="status">
          <el-radio label="1">在售</el-radio>
          <el-radio label="2">停售</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'comboAddView',
  data() {
    return {
      title: '',
      status: '',
      price: '',
      description: '',
      unitList: [],
      unitNo: [],
      commodityList: [],
      commodityArray: [],
      chooseCommodity: [],
      numbers: [],
      timeType: 0,
      beginTime: '',
      endTime: ''
    };
  },
  mounted() {
    this.getUnitMember();
  },
  methods: {
    handleChange() {
      let self = this;
      this.chooseCommodity = [];
      this.commodityArray.forEach(v => {
        self.commodityList.forEach(vv => {
          if (v == vv.number) {
            self.chooseCommodity.push(vv);
          }
        })
      })
    },
    confirm() {
      this.addOrEditCommodity();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditCommodity() {
      let commoditys = [];
      let commodity = {};
      for (let i = 0; i < this.commodityArray.length; i++) {
        commodity.commodityNo = this.commodityArray[i];
        commodity.commodityQuantity = this.numbers[i];
        commoditys.push(commodity);
      }
      let self = this;
      let params = {
        title: this.title,
        status: this.status,
        commodityType: 11,
        price: this.price,
        unitNo: this.unitNo[this.unitNo.length - 1],
        commodityArray: JSON.stringify(commoditys)
      };
      if (this.timeType == 1) {
        params.timeType = 1;
        params.beginTime = this.beginTime;
        params.endTime = this.endTime;
      }
      this.$http.post('/managementPlatform/admin/addAndEditCommodity', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "添加成功!",
          center: true
        });
        self.$emit('addSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
    getUnitMember() {
      let self = this
      this.$http.post('/managementPlatform/unit/queryManagedUnit'
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
    getCommodity(value) {
      let self = this;
      let params = {
        unitNo: value
      }
      this.$http.post('/managementPlatform/admin/getCommodityForUnit', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.commodityList = res.ldata;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onDeleteBtnClick(index) {
      this.commodityArray.splice(index, 1);
      this.handleChange();
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 600px;
    margin: 0;

    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }
  }

  .fixed-width-100 {
    width: 100px;
    vertical-align: top;
  }

  .fixed-width-150 {
    width: 150px;
    vertical-align: top;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .text {
    line-height: 32px;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/commodityMgmt/comboAddView.vue